const routerPhotos = [
  {
    path: "/fotografo/upload",
    name: "UploadPhoto",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "UploadPhoto" */ "@/views/Photo/Upload.vue"),
  },
  {
    path: "/fotografo/historico",
    name: "HistoryUpload",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "HistoryUpload" */ "@/views/Photo/History.vue"
      ),
  },
];

export default routerPhotos;
